var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStatusChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM30.8549 15.7913C31.004 15.6555 31.0146 15.4248 30.8787 15.2759L28.9092 13.119C28.7733 12.9701 28.5422 12.9595 28.3931 13.0952L17.8265 22.7153C17.6795 22.8491 17.4525 22.841 17.3155 22.6971L13.7485 18.9512C13.6095 18.8052 13.3782 18.7994 13.232 18.9382L11.1136 20.9494C10.9674 21.0883 10.9615 21.3192 11.1006 21.4652L17.1331 27.8005C17.2701 27.9444 17.4972 27.9524 17.6441 27.8187L30.8549 15.7913Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatusChecked);
export default __webpack_public_path__ + "static/media/icon_status-Checked.e23669896f5320257a3ed16a5d5a39bd.svg";
export { ForwardRef as ReactComponent };